import formatePrice from '../utils/formatePrice'
import { getString } from '../utils/constants'

const renderItem = route => `
  <li class="item" data-result-list-item-id="${route.fromId}">
    <a href="${route.url}" target="_blank">
      <span class="route-type">
        <img src="./images/${route.type.toLowerCase()}.png" alt="${route.type.toLowerCase()}" />
      </span>
      <div class="result-list-from">
        <span class="result-list-from-label">Odkud:</span>
        <span class="result-list-from-name">${route.fromName}</span>
        <span class="result-list-from-iata">(${route.from})</span>
      </div>
      <div class="result-list-to">
        <span class="result-list-to-label">Kam:</span>
        <span class="result-list-to-name">${route.toName}</span>
        <span class="result-list-to-iata">(${route.to})</span>
      </div>
      <div class="result-list-price">
        <div class="result-list-price-wrap">
          <span class="result-list-price-label">Od:</span>
          <span class="result-list-price-cost">${formatePrice(route.total)}&nbsp;${getString('CURRENCY')}</span>
        </div>
        <img class="result-list-airline" src="https://zdroje.letenky.cz/miranda/airline-logos/${route['airline-code']}.gif" />
      </div>
      <span class="result-list-booking">${getString('BOOK_IN')}</span>
    </a>
  </li>
`
export default renderItem



// WEBPACK FOOTER //
// ./app/result-list/item.js